import { datastreamQueryKeys } from '@/common/query-keys';

export const nthQueryKeys = {
  base: [...datastreamQueryKeys.base, 'nth'] as const,
  mailingSummary: (mailingId: number) => {
    return [...nthQueryKeys.base, 'mailing-summary', mailingId] as const;
  },
  twentileCounts: (mailingId: number) => {
    return [...nthQueryKeys.base, 'twentile-count', mailingId] as const;
  },
} as const;
